import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { MeasurementToolsDetailsModel } from '../models/low-level/measurement-tools-details.model';
import { MeasurementToolState } from '../state/measurement-tools/measurement-tools-collection.state';

export interface OdataMeasurementToolsInterface {
    getMeasurementTools(): Observable<MeasurementToolsDetailsModel[]>;
    getMeasurementToolsState(): Observable<MeasurementToolState[]>;
}

export const OdataMeasurementToolsInstanceToken = new InjectionToken<OdataMeasurementToolsInterface>(
    'OdataMeasurementToolsInterface',
);
